import { render } from "./PrivacyPolicyWeb.vue?vue&type=template&id=630dd392"
const script = {}

import exportComponent from "/var/www/lily-plant-frontend/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__